module.exports = __webpack_public_path__ + "img/3b22497c94053cad5fca009c4a820bb6.png";